module.exports = __webpack_public_path__ + "img/mongodb.e7225fa3.png";